import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { BrokerFormFieldNames } from './BrokerFormFieldNames';
import { BrokerFormValues } from './BrokerFormValues';
import { brokerValidationRules } from './brokerValidationRules';

const brokerFormConfig = createFormConfig<BrokerFormValues>(
  brokerValidationRules as ValidationRules<keyof BrokerFormValues>,
  {
    [AddressFormFieldNames.Country]: 'FR',
    [BrokerFormFieldNames.Collaborators]: [],
    // Variant par défaut de la nature CRT ('CLASSIQUE' est un sentinelle front :
    // le back reçoit sousNature null — voir buildCreateBrokerCommand).
    [BrokerFormFieldNames.SousNature]: 'CLASSIQUE',
  }
);

export { brokerFormConfig };
